var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-create-client',{attrs:{"selection-disabled":""},on:{"close":function($event){return _vm.$router.push({ name: 'profile', tab: 'sucursales' })}}})}
var staticRenderFns = []

export { render, staticRenderFns }